import { Trans } from '@common/i18n/trans';
import { useFormContext } from 'react-hook-form';
import { FormSelect } from '@common/ui/forms/select/select';
import { Item } from '@common/ui/forms/listbox/item';
import { Button } from '@common/ui/buttons/button';
import { DeleteIcon } from '@common/icons/material/Delete';
import { useEffect } from 'react';
import { useRemoveItemRateSheet } from '@app_modules/requests/use-remove-item-rate-sheet';
import { SheetNameAction } from './sheet-name-action';
import { useTrans } from '@common/i18n/use-trans';
import { MdFormatAction } from './md-format-action';

export function ParentRowSheet({
  id,
  pidx,
  market_rate_date,
  item,
  subItems,
  onAddSubItems,
  investor_codes,
  cnt,
  setCnt,
  removeParent,
  last,
  changeInvestorCode,
  fileItems,
  sheetNames,
  loanProgramTypes,
}: {
  id: number;
  pidx: number;
  market_rate_date: string;
  item: any;
  subItems: any;
  onAddSubItems: any;
  investor_codes: string[];
  cnt: number;
  setCnt: any;
  removeParent: any;
  last: number;
  changeInvestorCode: any;
  fileItems: any;
  sheetNames: any;
  loanProgramTypes: any
}) {
  const { trans } = useTrans();
  const { watch } = useFormContext<any>();
  const investor_code = watch(`${pidx}_investor_code`);

  useEffect(() => {
    if (investor_code) {
      changeInvestorCode(investor_code);
    }
  }, [investor_code, changeInvestorCode]);

  const removeItemRateSheet = useRemoveItemRateSheet(id, investor_code);

  return (
    <>
      <tr className="bg-gray-300">
        <th scope="col" className="w-[20%] bg-gray-300 text-md font-medium text-gray-900 px-6 py-4 text-left">
          <Trans message="Lender Rate Sheet Name" />
        </th>
        <th scope="col" className="w-[5%] bg-sgray-300 text-md font-medium text-gray-900 px-6 py-4 text-left"></th>
        <th className="w-[75%]"></th>
      </tr>

      <tr key={`parent-row-${pidx}`} className="border-b transition duration-300 ease-in-out hover:bg-gray-100 w-[100%]">
        <td className="text-sm text-gray-900 px-6 py-4 whitespace-nowrap">
          <FormSelect
            name={`${pidx}_investor_code`}
            selectionMode="single"
            required
            placeholder={trans({ message: 'Select lender code' })}
            className="w-150"
            onSelectionChange={(val) => {
              changeInvestorCode(val.toString());
            }}
          >
            {investor_codes?.map((investor_code: string) => (
              <Item value={investor_code} key={investor_code}>
                <Trans message={investor_code} />
              </Item>
            ))}
          </FormSelect>
        </td>
        <td className="text-sm text-gray-900 font-light px-6 py-4 whitespace-nowrap">
          <Button
            size={'xs'}
            variant="outline"
            color="red"
            onClick={() => {
              removeParent(true, pidx);
              if (id && investor_code) {
                removeItemRateSheet.mutate(
                  { id: id, investor_code: investor_code },
                  {
                    onSuccess: (response) => {
                      // Handle success if needed
                    },
                  }
                );
              }
            }}
            disabled={removeItemRateSheet.isPending}
          >
            <DeleteIcon />
          </Button>
        </td>
        <td className="text-sm text-gray-900 px-6 py-4 whitespace-nowrap" colSpan={2}>
          <table className='w-full'>
            <tr className='w-full'>
              <td className='flex w-[40%]' >
                <SheetNameAction
                  id={id}
                  market_rate_date={market_rate_date}
                  key={`action-${pidx}`}
                  pindex={pidx}
                  fileItems={fileItems}
                  investor_code={investor_code}
                />
              </td>
              
              <td className='w-[40%]'>

                <MdFormatAction
                  id={id}
                  market_rate_date={market_rate_date}
                  key={`action-${pidx}`}
                  pindex={pidx}
                  sheetNames={sheetNames}
                  loanProgramTypes={loanProgramTypes}
                  investor_code={investor_code}
                />
              </td>
              <td className='w-[20%]'></td>
            </tr>
          </table>
        </td>
      </tr>
    </>
  );
}